import { gql } from '@apollo/client';
import AboutUsPage from '~/components/LongRead/AboutUs';
import type {
  getAboutUsPageContent,
  getAboutUsPageContent_aboutUsModel,
} from '~/types/generated/cms/getAboutUsPageContent';
import { getDatoClient } from 'src/datoCMS/datoCmsClient';
import { AboutUsPageFragment } from 'src/datoCMS/fragments/fragments';
import type { GetStaticProps } from 'next';

const GET_ABOUT_US_PAGE_CONTENT = gql`
  ${AboutUsPageFragment}
  query getAboutUsPageContent {
    aboutUsModel {
      ...AboutUsFragment
    }
  }
`;

interface PageProps {
  page: getAboutUsPageContent_aboutUsModel;
}

const PageContent: React.FC<PageProps> = ({ page }) => <AboutUsPage page={page as any} />;

export const getStaticProps: GetStaticProps<PageProps> = async ({ preview }) => {
  const datoClient = getDatoClient(preview);

  const { data } = await datoClient.query<getAboutUsPageContent>({
    query: GET_ABOUT_US_PAGE_CONTENT,
  });

  const renderedPageData = data.aboutUsModel;

  if (!renderedPageData) return { notFound: true };

  return {
    props: { page: renderedPageData },
    revalidate: 60,
  };
};

export default PageContent;
